import { MappedClass, MappedProperty } from '@h5s/util-object';
import { ZPrinterHealthStatus } from './z-printer-health-status';

@MappedClass()
export class ZPrinterWorkerHealthEntry {
  @MappedProperty()
  last_update?: string;

  @MappedProperty()
  message?: string;

  @MappedProperty()
  retry_count?: number;

  @MappedProperty()
  service_id?: string;

  @MappedProperty()
  state?: string;

  @MappedProperty()
  status?: ZPrinterHealthStatus;
}
